import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Box, Text } from '@primer/react';
import ComponentLayout from '~/src/layouts/component-layout';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <img width="960" alt="An image of the breadcrumb component" src="https://user-images.githubusercontent.com/586552/204619264-27de7458-1a77-445f-bc56-83472bf30bfe.png" />
    <h2>{`Usage`}</h2>
    <p>{`Breadcrumbs are used to show taxonomical context on pages that are many levels deep in a site’s hierarchy. Breadcrumbs show and link to pages higher up in the ancestry.`}</p>
    <p>{`Breadcrumbs are most appropriate on pages that:`}</p>
    <ul>
      <li parentName="ul">{`Are many levels deep on a site`}</li>
      <li parentName="ul">{`Do not have a section-level navigation`}</li>
      <li parentName="ul">{`May need the ability to quickly go back to the previous (parent) page`}</li>
      <li parentName="ul">{`All items must contain links, with the last item as the user's current context`}</li>
    </ul>
    <h2>{`Anatomy`}</h2>
    <p>{`Breadcrumbs are made of links (indicating parents), dividers, and the current page. The default breadcrumbs component can be modified to change the number of items within the chain.`}</p>
    <img width="960" alt="An image showing the anatomy of the breacrumb component" src="https://user-images.githubusercontent.com/586552/204619263-c21f06c1-433d-4817-860b-f9d051836cd3.png" />
    <Caption mdxType="Caption">Note: The space between items is set to 0px as the divider has padding built into it.</Caption>
    <h2>{`Options`}</h2>
    <h3>{`Breadcrumb length`}</h3>
    <p>{`By default the breadcrumbs component can show up to 10 items within the chain.`}</p>
    <img width="960" alt="An image showing various breadcrumbs with different numbers of items in the breadcrumb chain" src="https://user-images.githubusercontent.com/586552/204618645-1abd2204-f197-402d-9b01-de648ddd1812.png" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      